(ns practitest.frontend.components2.dashboard.transforms.stacked-bar
  (:require [practitest.frontend.components2.dashboard.schema :as sc]
            [practitest.frontend.components2.dashboard.transforms.bar :as bar-transforms]))

(def StackedBarItem
  [:map
   [:category :string]
   [:group :string]
   [:value number?]])

(def StackedBarSeriesData
  [:map
   [:chart/legend
    [:vector
     [:map
      [:label :string]
      [:is-active :boolean]]]]
   [:chart/series-labels [:vector :string]]
   [:chart/data [:vector StackedBarItem]]])

(defn transform
  {:malli/schema [:=> [:cat [:map
                             [:chart/data sc/SeriesCategories]
                             [:chart/cell-width {:optional true} [:maybe [:enum :regular :double]]]]]
                  StackedBarSeriesData]}
  [{{:keys [series categories]} :chart/data
    :chart/keys                 [colors-palette toggle-legend cell-width]
    :or                         {toggle-legend {}}
    :as                         chart}]
  (let [categories-max-num  (bar-transforms/max-numbers-of-categories (or cell-width :regular))
        active?             #(toggle-legend % true)
        active-series       (filterv #(active? (:name %)) series)
        latest-categories (vec (take-last categories-max-num categories))

        max-value
        (->> (range (count latest-categories))
             (map (fn [idx]
                    (->> active-series
                         (map #(nth (:data %) idx 0))
                         (reduce + 0))))
             (apply max 0))

        legend (mapv (fn [{label :name}]
                       {:label     label
                        :is-active (active? label)})
                     series)]

    (merge chart
           {:chart/data
            (vec
             (mapcat (fn [idx category]
                       (map (fn [{group :name data :data}]
                              {:category category
                               :group    group
                               :value    (nth data idx 0)})
                            active-series))
                     (range (count latest-categories))
                     latest-categories))

            :chart/legend        legend
            :chart/series-labels (mapv :name active-series)
            :chart/categories    latest-categories
            :chart/max-value     max-value})))